var _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookingPanWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V11.5V3",
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3278_254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.25C0 0.111929 0.111929 0 0.25 0H23.75C23.8881 0 24 0.111929 24 0.25C24 1.2165 23.2165 2 22.25 2H1.75C0.783502 2 0 1.2165 0 0.25Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2H23.75V-2H0.25V2ZM22.25 0H1.75V4H22.25V0ZM1.75 0C1.88807 0 2 0.111928 2 0.25H-2C-2 2.32107 -0.321067 4 1.75 4V0ZM22 0.25C22 0.111929 22.1119 0 22.25 0V4C24.3211 4 26 2.32107 26 0.25H22ZM23.75 2C22.7835 2 22 1.2165 22 0.25H26C26 -0.992646 24.9926 -2 23.75 -2V2ZM0.25 -2C-0.992641 -2 -2 -0.992641 -2 0.25H2C2 1.2165 1.2165 2 0.25 2V-2Z",
    fill: "white",
    mask: "url(#path-2-inside-1_3278_254)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H17V16C17 16.5523 16.5523 17 16 17H8C7.44772 17 7 16.5523 7 16V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingPanWhiteOutline);
export default __webpack_public_path__ + "static/media/cookingPanWhiteOutline.28adb6ab1883e550321a089f7452b462.svg";
export { ForwardRef as ReactComponent };